import { Link } from "react-router-dom";
import { getHotEntries } from "@/hooks/useSiteData";
import SectionHeading from "@/components/base/SectionHeading";

export default function FocusBoard() {
  const [lead, ...rest] = getHotEntries(3);

  if (!lead) return null;

  return (
    <section className="border-b border-background-200 bg-background-50 px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="今日焦点"
        title="讨论最集中的三件事"
        desc="按当前热度排序，点进去可以看到完整的公开时间线与各方说明。"
        linkText="全部词条"
        linkTo="/ranking"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <Link
          to={`/entry/${lead.id}`}
          className="group relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-lg border border-background-200 md:min-h-[420px]"
        >
          <img
            src={lead.cover}
            alt={`${lead.name} · ${lead.title} 焦点配图`}
            title={`${lead.name} 焦点词条`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent"></div>
          <div className="relative p-5 md:p-7">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
              <i className="ri-fire-line"></i> 热度第一
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold text-white md:text-2xl">{lead.title}</h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-white/75">{lead.summary}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-200">
              查看完整时间线 <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>

        <div className="flex flex-col gap-5">
          {rest.map((entry) => (
            <Link
              key={entry.id}
              to={`/entry/${entry.id}`}
              className="group flex flex-1 flex-col justify-between rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/70 md:p-6"
            >
              <div>
                <span className="text-xs text-accent-700">持续关注 · {entry.updatedAt}</span>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                  {entry.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {entry.summary}
                </p>
              </div>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                {entry.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800"
                  >
                    #{tag}
                  </span>
                ))}
                <span className="ml-auto flex items-center gap-1 text-xs text-primary-700">
                  查看词条 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}